type GetBalconySpecificationCalculatedSurface = (
  lodgmentSurface: number,
  balconySurfaceOnRealLivingSurfaceRate: number
) => number;

export const getBalconySpecificationCalculatedSurface: GetBalconySpecificationCalculatedSurface = (
  lodgmentSurface,
  balconySurfaceOnRealLivingSurfaceRate
) => lodgmentSurface * balconySurfaceOnRealLivingSurfaceRate;
